export default __webpack_public_path__ + "assets/images/d26715de7c6eed77bfe00f007e504d26.png";